import app, { Component } from 'apprun';
import { isValidElement, showSaveStatusMessage } from '../utils';
import moment from 'moment';
import { teams } from '../api';

export default class CommonPropertyComponent extends Component {
  state = { dateFmt:'DD-MMM-YYYY' };

  view = (state) => {
    if (!state.item) {return;}
    return (

      <form id="frm-common-props-date-edit" class="form-horizontal" style={{ width: '450px' }} autocomplete="off">
        <div>
          <p style={{ 'white-space':'normal' }}>User Team membership start and end dates must fall within Team Start and End date.</p>
          <label>Team Start Date:</label> {moment(state.extra.TStartDate).format(state.dateFmt)}<br/>
          <label>Team End Date:</label> {state.extra.TEndDate===''?'':moment(state.extra.TEndDate).format(state.dateFmt)}<br/>
          <br/>
        </div>
        <div>
          { (state.validate)
            ?<span style={{ color:'green' }}>
              <label>Possible Range:&nbsp;</label>
              {state.minDate.format(state.dateFmt) + ' - ' +  state.maxDate.format(state.dateFmt)}
              <br/>
            </span>
            :<span  class="text-danger">
              * Data inconsistency detected, cannot suggest possible range.<br/>
              * WARNING: validation will not be performned on save
              <br/>
            </span>

          }
        </div>
        <br/>
        <div class="row">
          <div class="col-sm-12">{state.item.dispName}</div>
          <div class="col-sm-12">
            <input
              $pikaday
              id="inpText"
              size="62"
              class="form-control"
              value={state.newVal}
              oninput={(e) => {
                state.newVal = e.target.value;
              }}
            />
          </div>
        </div>
        <div id="inpTextErrMsg" class="text-danger"></div>
        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
          </a>
          <a
            type="button"
            class="btn btn-primary btn-xs"
            style={
              state.item.required || state.item.value === ''
                ? { display: 'none' }
                : { display: 'inline-block' }
            }
            onclick={() => this.run('delete')}>
            delete
          </a>
          <a
            type="button"
            class="btn btn-default btn-xs"
            onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>
      </form>
    );
  };

  update = {
    refresh: async (state, newState) => {
      state = { ...state, ...newState };
      const result = await teams.getTeamConstraints(newState.extra.CompanyPersonID);
      state.teamMemberId = result?.teamMemberId;
      if(result?.status === 'OK') {
        state.validate = true;
        if(state.item.fieldName === 'TMStartDate') {
          state.minDate = moment(result.minPossibleStartDateforTeam);
          state.maxDate = moment(result.maxPossibleStartDateforTeam);
        } else {
          state.minDate = moment(result.minPossibleEndDateforTeam);
          state.maxDate = moment(result.maxPossibleEndDateforTeam);
        }
      } else {
        state.validate = false;
        state.minDate = state.maxDate = null;
      }

      return {
        ...state,
        ...newState,
        newVal: newState.item.value ? moment(newState.item.value).format('DD-MMM-YYYY') : null,
        picker: null,
      };
    },

    save: async (state) => {
      state.newVal = (document.getElementById('inpText') as HTMLInputElement).value;
      if (!state.newVal) {return;}
      if (isValidElement('inpText', 'DateStr')) {
        if(this.checkBounds(state)) {
          try {
            const result = await teams.updateTeamDate((state.item.fieldName=== 'TMStartDate' ? 'startdate' : 'enddate'), state.extra.CompanyPersonID, state.teamMemberId , state.newVal);
            showSaveStatusMessage(result ? state.item.dispName: null);
            if(result){state.caller.run(state.cancel, state.panelId);}
          } catch(err) {
            const errMsg = await err.json();
            const errDiv = (document.getElementById('inpTextErrMsg') as HTMLDivElement);
            errDiv.innerHTML = errMsg;
          }
        } else {
          const errDiv = (document.getElementById('inpTextErrMsg') as HTMLDivElement);
          errDiv.innerHTML = '* date should be between possible range';
        }
      }
    },

    delete: async (state) => {
      state.newVal = '31-Dec-9999';
      if(this.checkBounds(state)) {
        try {
          const result = await teams.updateTeamDate('enddate', state.extra.CompanyPersonID, state.teamMemberId , state.newVal);
          showSaveStatusMessage(result ? state.item.dispName: null);
          if(result){state.caller.run(state.cancel, state.panelId);}
        } catch(err) {
          const errMsg = await err.json();
          const errDiv = (document.getElementById('inpTextErrMsg') as HTMLDivElement);
          errDiv.innerHTML = errMsg;
        }
      } else {
        const errDiv = (document.getElementById('inpTextErrMsg') as HTMLDivElement);
        errDiv.innerHTML = '* cannot be deleted, end date is required.';
      }
    },
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };

  checkBounds = (state) => {
    if(!state.validate) { return true; }
    const inpDate = moment(state.newVal).toDate();
    const minDate = state.minDate.toDate();
    const maxDate = state.maxDate.toDate();
    return ((inpDate >= minDate) && ((inpDate <= maxDate)));
  }
}
